import { render, staticRenderFns } from "./SelfBuildingSquareSpinner.vue?vue&type=template&id=2543d096&scoped=true"
import script from "./SelfBuildingSquareSpinner.vue?vue&type=script&lang=js"
export * from "./SelfBuildingSquareSpinner.vue?vue&type=script&lang=js"
import style0 from "./SelfBuildingSquareSpinner.vue?vue&type=style&index=0&id=2543d096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543d096",
  null
  
)

export default component.exports